import { render, staticRenderFns } from "./IncidentRiskScenariosTable.vue?vue&type=template&id=26ebcfbe&"
import script from "./IncidentRiskScenariosTable.vue?vue&type=script&lang=js&"
export * from "./IncidentRiskScenariosTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports